import React from "react";

type Props = {
  name?: string,
  label?: string,
  placeholder?: string,
  required?: boolean,
  value: string,
  onChange: (e: any) => void
}

const PasswordInput : React.FC<Props> = ({
  name = "password",
  label = "Your Password",
  placeholder = "",
  required = false,
  value,
  onChange
}) => {
  return (
    <div className="form-input-wrapper">
      <label className="text-input__label label-input" htmlFor={name}>
        {label}
      </label>
      <input
        className="text-input"
        type="password"
        name={name}
        id={name}
        placeholder={placeholder}
        required={required}
        value={value}
        maxLength={25}
        onChange={onChange}
      />
    </div>
  );
};

PasswordInput.defaultProps = {
  name: "password",
  label: "Your Password",
  placeholder: "",
  required: false,
  value: ""
};

export default PasswordInput;
